import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as freightSelector, actions as freightActions } from 'ducks/supplierEnquiry/activity/freight';
import { fetch } from 'api/supplierEnquiry/activity/freight';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { selectors as supplierSelectors } from 'ducks/supplierEnquiry/supplier';


export const mapStateToProps = state => {
  const params = new URLSearchParams(location.search);

  return {
    gridName: 'SupplierActivityFreight',
    columnDefs: freightSelector.columns(state),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
    gridOptions: freightSelector.gridOptions(state),
    filterRow: freightSelector.filterRow(state),
    selectedFilters: freightSelector.selectedFilters(state),
    appliedFilters: freightSelector.filterRow(state) && filterSelectors.getFilters(state, freightSelector.filterRow(state).formName),
    reqParams: (supplierSelectors.selected(state) || params.get('Supplier'))
      &&
    {
      SupplierId: (supplierSelectors.selected(state) && supplierSelectors.selected(state).Supplier) || params.get('Supplier')
    },
    apiMethod: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier') ? fetch : () => Promise.resolve(null)
  }
};

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: freightActions.setSelected,
  applyFilters: filterActions.applyFilters
}
